import {
  SET,
  LOAD_INITIAL_STATE,
  SpecialInstructionsActions,
} from '../../actions/special-instructions-actions/special-instructions.actions';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { OrderBuilderActions, RESET_BUILDER } from '../../../../actions/order-builder.actions';

/**
 * Properties for this type of form-control
 */
export interface ISpecialInstructionState {
  selected: string;
  required: boolean;
  disabled: boolean;
  visible: boolean;
  maxlength?: number;
  label?: string;
}

/**
 * A hard-coded default state for this form-field
 * @type {ISpecialInstructionState}
 */
export const initialState: ISpecialInstructionState = {
  selected: '',
  required: false,
  disabled: false,
  visible: false,
  maxlength: null,
  label: '',
} as ISpecialInstructionState;

/**
 * Sets or loads the state of the form-field according to the Action supplied.
 * @param {ISpecialInstructionState} state
 * @param {SpecialInstructionsActions} action
 * @return {ISpecialInstructionState}
 */
export function specialInstructionsReducer(
  state = initialState,
  action: SpecialInstructionsActions | OrderBuilderActions,
): ISpecialInstructionState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const specialInstructionConfig: ILocationConfigUnit = action.payload as ILocationConfigUnit;
        return {
          ...state,
          disabled: specialInstructionConfig.disabled,
          required: specialInstructionConfig.required,
          visible: specialInstructionConfig.visible,
          maxlength: specialInstructionConfig.maxlength,
          label: specialInstructionConfig.label,
        } as ISpecialInstructionState;
      } else {
        return {
          ...initialState,
        };
      }
    }
    case SET: {
      return {
        ...state,
        selected: action.payload,
      };
    }
    case RESET_BUILDER: {
      return {
        ...state,
        selected: null,
      };
    }
    default: {
      return state;
    }
  }
}
